import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['Sentís que algo no está bien, pero no conseguís identificar qué necesitás.', 'Buscás rituales, consejos y prácticas aisladas en diferentes lugares.', 'Probás distintas herramientas sin saber cuál elegir para el momento que estás atravesando.', 'Empezás rutinas demasiado exigentes y terminás abandonándolas.', 'Realizás prácticas sin detenerte a observar cómo te sentías antes y cómo te sentís después.', 'Querés dedicarte un momento, pero lo postergás porque no sabés cómo comenzar.'];
const after = ['Identificás lo que estás atravesando y encontrás una práctica relacionada.', 'Tenés las herramientas organizadas dentro de un mismo sistema visual.', 'Elegís una práctica concreta según lo que necesitás en ese momento.', 'Empezás con propuestas breves que podés adaptar a tu tiempo y a tu experiencia.', 'Observás cómo te sentís antes y después de cada práctica.', 'Contás con un primer paso claro para comenzar a acompañarte desde hoy.'];
export function PainSection() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-202" data-mp="3nknpgzt1l2bz">
      <div className="mx-auto max-w-5xl" data-id="element-203" data-mp="5gccgfxgs5x3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-204" data-mp="5fappe735uzj">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-205" data-mp="g7usmktl55a">
            ¿Sentís que necesitás volver a vos, pero no sabés por dónde empezar?
          </h2>
          <p className="mt-3 text-sm italic leading-relaxed text-plum/70 sm:text-base" data-id="element-206" data-mp="33xyeqjow5dfu">
            Si te identificás con una sola de estas situaciones, Aura Viva 2026 puede ayudarte a
            comenzar con una práctica concreta.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-207" data-mp="3dtj9bwrmrbfk">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-rose bg-card p-6 sm:p-8" data-id="element-208" data-mp="2q502llo8b6pl">
            <h3 className="mb-5 text-lg font-bold text-plum sm:text-xl" data-id="element-209" data-mp="u1c5bnoqtshw">Cuando no tenés una guía</h3>
            <ul className="space-y-3" data-id="element-210" data-mp="yu56y2ox0kpr">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-211" data-mp="12tx99xnptumo">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose/15 text-rose" data-id="element-212" data-mp="657u4f3h3g4e">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-213" data-mp="b52l0in905pg" />
                  </span>
                  <span className="text-sm leading-relaxed text-plum/80" data-id="element-214" data-mp="f4l0gywavokw">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border-l-4 border-aura bg-lavender p-6 ring-1 ring-inset ring-gold/20 sm:p-8" data-id="element-215" data-mp="1qkt659713g0s">
            <h3 className="mb-5 text-lg font-bold text-plum sm:text-xl" data-id="element-216" data-mp="20qt5e21gnoal">Con Aura Viva 2026</h3>
            <ul className="space-y-3" data-id="element-217" data-mp="1vw6udzzajxr1">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-218" data-mp="1rvmvorz2km2s">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-aura/15 text-aura" data-id="element-219" data-mp="1mxuuf7cjbnlx">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-220" data-mp="1hxgwwj8k7w25" />
                  </span>
                  <span className="text-sm leading-relaxed text-plum/80" data-id="element-221" data-mp="1czx66juodqtb">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-base font-medium leading-relaxed text-plum sm:text-lg" data-id="element-222" data-mp="37dg9697h61m0">
          No necesitás hacer todo al mismo tiempo. Solo necesitás saber cuál puede ser{' '}
          <span className="font-serif-display font-bold text-aura" data-id="element-223" data-mp="3aft6sdghnj5p">tu próximo paso</span>.
        </p>
      </div>
    </section>;
}